import { render, staticRenderFns } from "./item-total.vue?vue&type=template&id=ad20a32e"
import script from "./item-total.vue?vue&type=script&lang=js"
export * from "./item-total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports